// displayLabels.js — vocabulary normalization for reconciled catalog data
// FragranceOS Visibility Pass (2026-06-23)
//
// The reconciled `catalog` uses lowercase vocab (autumn, soft/moderate/strong/beast);
// the collection UI (FragranceCard, FragranceDetailPage) is keyed to Title-case
// (Fall, Soft/Moderate/Loud). Run catalog-sourced values through these helpers
// before rendering so the existing emoji/color maps resolve. Idempotent — safe on
// already-Title-cased collection values too.

const SEASON_MAP = { spring: 'Spring', summer: 'Summer', autumn: 'Fall', fall: 'Fall', winter: 'Winter' }
// Catalog projection vocab → UI's 3-tier (Soft/Moderate/Loud)
const PROJECTION_MAP = {
  soft: 'Soft', moderate: 'Moderate', strong: 'Loud', beast: 'Loud', loud: 'Loud',
}

const titleCase = (s) =>
  String(s || '').trim().replace(/\b\w/g, (c) => c.toUpperCase())

export const normSeason = (s) =>
  SEASON_MAP[String(s || '').trim().toLowerCase()] || titleCase(s)

export const normSeasons = (arr) =>
  Array.isArray(arr) ? [...new Set(arr.map(normSeason))] : []

export const normProjection = (p) =>
  PROJECTION_MAP[String(p || '').trim().toLowerCase()] || titleCase(p)

// scent_family is stored as a pipe/comma string e.g. "spicy|woody|aromatic".
// Return a clean array of Title-cased tokens for chip rendering.
export const scentFamilyTokens = (sf) =>
  String(sf || '')
    .split(/[|,;]/)
    .map((t) => t.trim())
    .filter(Boolean)
    .map(titleCase)

// gender_class → short display + symbol
const GENDER = {
  men:    { label: 'Men',    symbol: '♂' },
  women:  { label: 'Women',  symbol: '♀' },
  unisex: { label: 'Unisex', symbol: '⚥' },
}
export const genderLabel  = (g) => GENDER[String(g || '').trim().toLowerCase()]?.label  || ''
export const genderSymbol = (g) => GENDER[String(g || '').trim().toLowerCase()]?.symbol || ''

// displayName — drop a leading house name from a fragrance name for display,
// so a result row doesn't repeat the house that's already shown beneath it.
// e.g. displayName('Azzaro Pour Homme Elixir', 'Azzaro') -> 'Pour Homme Elixir'.
// Conservative: only strips a whole leading "<house> " token; if the remainder
// would be empty, the original name is kept.
export const displayName = (name, house) => {
  const n = String(name || '').trim()
  const h = String(house || '').trim()
  if (!h) return n
  if (n.toLowerCase().startsWith(h.toLowerCase() + ' ')) {
    const rest = n.slice(h.length).trim()
    return rest || n
  }
  return n
}
